import React from "react";
import weblogo from "assets/img/footer-logo.png";
import Footerimage from "assets/img/footer-image.png";
import "components/Footer/Footer.css";
import { Link } from "react-router-dom";
// import Pdf from 'assets/img/TC-TECNORN-TOB-FD-2.pdf';
import XLogo from "assets/img/x.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GooglePlayDownloadButton from "data/GooglePlayDownloadButton";
import DownloadButton from "data/DownloadButton.jsx";
import { DropdownButton } from "react-bootstrap";
import useMediaQuery from "utils/CustonHooks/UseDeviceResponsiveHook";
import Threads from "assets/svg/svg";

const Footer = () => {
  const matches = useMediaQuery("(min-width: 768px)");
  const handleRedirectToPdf = () => {
    window.location.href = "#"; // Replace with your PDF file URL
  };
  return (
    <div>
      <div className="footer">
        <footer className="footer" role="contentinfo">
          <div className="container MainFooter">
            <div className="row align-items-center" style={{ padding: "0px" }}>
              <div className="col-12 hero-text-image">
                <div className="row" style={{ padding: "0px" }}>
                  {!matches && (
                    <div className="col-lg-4  ">
                      <div className="logo">
                        <Link to="https://tecmch.co.uk/">
                          <img className="img-fluid" src={weblogo} />
                        </Link>
                      </div>
                      <br />

                      <p className="footer-desc">
                        Simplifying fleet management with proactive maintenance
                        and compliance tools to boost efficiency and reduce
                        costs for any fleet or asset operation.
                      </p>
                      <div className="contact-line">
                        <span className="fa fa-envelope contact-icon" />{" "}
                        {/* <a href="mailto:info@tecmch.co.uk">info@tecmch.co.uk</a> */}
                       <a
  href="https://mail.google.com/mail/?view=cm&fs=1&to=info@tecmch.co.uk"
  target="_blank"
  rel="noopener noreferrer"
>
  info@tecmch.co.uk
</a>



                      </div>
                      <div className="contact-line">
                        <span className="fa fa-phone contact-icon" />{" "}
                        <a href="tel:441332323989">+441332323989</a>
                      </div>
                      <div className="social-icons">
                        <a
                          href="https://www.facebook.com/TecMCH/"
                          className="fa fa-facebook"
                          aria-label="Facebook"  target="_blank"
                        ></a>
                        <a
                          href="https://www.linkedin.com/company/104342201/"
                          className="fa fa-linkedin"
                          aria-label="LinkedIn"  target="_blank"
                        ></a>
                        <a
                          href="https://x.com/tecmch"
                          className="fa"  target="_blank"
                          aria-label="X"
                        >
                          <img width={15} src={XLogo} alt="Blue 'X' logo on a transparent background, symbolising a Twitter organisation." />
                        </a>
                        <a
                          href="https://www.instagram.com/tecmch/"
                          className="fa fa-instagram"
                          aria-label="Instagram"  target="_blank"
                        ></a>
                        <a
                          href="https://www.quora.com/profile/TecMCH"
                          className="fa fa-quora"
                          aria-label="Quora"  target="_blank"
                        ></a>
                        <a
                          href="https://uk.pinterest.com/tecmchofficial/"
                          className="fa fa-pinterest"
                          aria-label="Pinterest"  target="_blank"
                        ></a>
                        <a
                          href="https://www.threads.com/tecmch/"
                          className="fa threads"  target="_blank"
                          aria-label="Threads"
                        >
                          <Threads />
                        </a>
                      </div>
                    </div>
                  )}
                  {matches && (
                    <div className="col-lg-4 ">
                      {/* footer-logo */}
                      <div className="logo" style={{ width: "160px" }}>
                        <Link to="https://tecmch.co.uk/">
                          <img className="img-fluid" src={weblogo} alt="TecMCH logo featuring sleek lettering and a contemporary design that represents technology and innovation." />
                        </Link>
                      </div>
                      <br />

                      <p className="footer-desc">
                        Simplifying fleet management with proactive maintenance
                        and compliance tools to boost efficiency and reduce
                        costs for any fleet or asset operation.
                      </p>
                      <div className="contact-line">
                        <span className="fa fa-envelope contact-icon" />{" "}
                        {/* <a href="mailto:info@tecmch.co.uk">info@tecmch.co.uk</a> */}
                       <a
  href="https://mail.google.com/mail/?view=cm&fs=1&to=info@tecmch.co.uk"
  target="_blank"
  rel="noopener noreferrer"
>
  info@tecmch.co.uk
</a>



                      </div>
                      <div className="contact-line">
                        <span className="fa fa-phone contact-icon" />{" "}
                        <a href="tel:441332323989">+441332323989</a>
                      </div>
                      <div className="social-icons">
                        <a
                          href="https://www.facebook.com/TecMCH/"
                          className="fa fa-facebook"
                          aria-label="Facebook"
                           target="_blank"
                        ></a>
                        <a
                          href="https://www.linkedin.com/company/104342201/"
                          className="fa fa-linkedin"
                          aria-label="LinkedIn"
                           target="_blank"
                        ></a>
                        <a
                          href="https://x.com/tecmch"
                          className="fa"
                          aria-label="X"
                           target="_blank"
                        >
                          <img width={15} src={XLogo} />
                        </a>
                        <a
                          href="https://www.instagram.com/tecmch/"
                          className="fa fa-instagram"
                          aria-label="Instagram"  target="_blank"
                        ></a>
                        <a
                          href="https://www.quora.com/profile/TecMCH"
                          className="fa fa-quora"
                          aria-label="Quora"  target="_blank"
                        ></a>
                        <a
                          href="https://uk.pinterest.com/tecmchofficial/"
                          className="fa fa-pinterest"
                          aria-label="Pinterest"  target="_blank"
                        ></a>
                        <a
                          href="https://www.threads.com/tecmch/"
                          className="fa threads"
                          aria-label="Threads"
                           target="_blank"
                        >
                          <Threads />
                        </a>
                      </div>
                    </div>
                  )}

                  {/* 
                  {!matches && <div className='row'><div >
                    <a href="https://www.facebook.com/TecMCHOfficial/" className="fa fa-facebook"></a>
                    <a href="https://www.linkedin.com/company/104342201/" className="fa fa-linkedin"></a>
                    <a href="https://x.com/tecmch" className="fa"><img width={15} src={XLogo} /></a>
                    <a href="https://www.instagram.com/tecmch/" className="fa fa-instagram"></a>
                    <a href="https://www.quora.com/profile/TecMCH" className="fa fa-quora"></a>
                    <a href="https://uk.pinterest.com/tecmchofficial/" className="fa fa-pinterest"></a>
                    <a href="https://www.instagram.com/tecmch/" className="fa threads"><Threads /></a>

                  </div></div>} */}

                  <div className="col-lg-8 ndcol">
                    <h3>What are you waiting for?</h3>
                    <p>Join hundreds of thousands of happy users.</p>
                    <div className="row justify-content-md-normal1 ">
                      <div
                        className="col-lg-4 justify-content-md-normal2"
                        style={{ textAlign: "right" }}
                      >
                        {/* <Link to="/"><img  width={120} src={DownloadButton} /></Link> */}
                        <DownloadButton></DownloadButton>
                      </div>
                      <div className="col-lg-4 justify-content-md-normal3"></div>
                      <div
                        className="col-lg-4 justify-content-md-normal2"
                        style={{ textAlign: "left" }}
                      >
                        {/* <Link tp="/"><img  width={120} src={DownloadButton1} /></Link> */}
                        <GooglePlayDownloadButton></GooglePlayDownloadButton>
                      </div>
                    </div>
                    <div className="row justify-content-md-normal1 ">
                      <img className="pb-0 pt-30" src={Footerimage} alt="Screen of the TecMCH app, showcasing the screen of the app’s Signup Page."/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <div className="footer bottomBar">
        <div className="container">
          <div className="row justify-content" style={{ paddingTop: "10px" }}>
            <div className="col-md-8">
              <p className="copyright" style={{  textAlign: matches ? "left" : "center" }}>
                &copy; Copyrights {new Date().getFullYear()} TecMCH All Rights
                Reserved Powered By{" "}
                <a
                  href="https://techvezoto.com/"  target="_blank"
                  style={{ textDecoration: "underline" }}
                >
                  Tech Vezoto
                </a>
              </p>
            </div>
            <div className="col-md-4">
              <div className=" " style={{  textAlign: matches ? "end" : "center" }}>
                <p>
                  {/* <a
                    onClick={handleRedirectToPdf}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                  >
                    Terms of Business{" "}
                  </a>{" "} */}
                  &nbsp;{" "}
                  <Link
                    to="/privacy-policy"  target="_blank"
                    style={{ textDecoration: "underline" }}
                  >
                    Privacy Policy
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
